var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchAndFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4503_9279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3426 7.54286H15.6849C16.3716 7.54286 16.7149 8.37523 16.2304 8.85978L14.1279 10.9626C12.2123 10.8375 10.6544 9.40146 10.3426 7.54286Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88789 7.54286C7.13835 10.3222 8.89646 12.6669 11.3381 13.7527L10.2857 14.8052V23.2279C10.2857 23.8551 9.57921 24.215 9.0719 23.8599L6.50047 22.0606C6.29424 21.9162 6.17142 21.6803 6.17142 21.4286V14.8052L0.226861 8.85978C-0.258657 8.37426 0.0871036 7.54286 0.772325 7.54286H6.88789Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1101 10.6295C20.8275 9.5464 21.2453 8.24759 21.2453 6.8512C21.2453 3.06739 18.1779 0 14.3941 0C10.6102 0 7.54286 3.06739 7.54286 6.8512C7.54286 10.635 10.6102 13.7024 14.3941 13.7024C15.7904 13.7024 17.0893 13.2846 18.1723 12.5673L21.6608 16.0558C22.196 16.5909 23.0635 16.5909 23.5987 16.0558C24.1338 15.5207 24.1338 14.6531 23.5987 14.118L20.1101 10.6295ZM19.1899 6.8512C19.1899 9.49987 17.0427 11.647 14.3941 11.647C11.7454 11.647 9.59822 9.49987 9.59822 6.8512C9.59822 4.20253 11.7454 2.05536 14.3941 2.05536C17.0427 2.05536 19.1899 4.20253 19.1899 6.8512Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4503_9279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAndFilterIcon);
export default __webpack_public_path__ + "static/media/SearchAndFilterIcon.adaa85b7c148a2e2922cb1881342cf67.svg";
export { ForwardRef as ReactComponent };